import React from 'react';

class VideoArea extends React.Component {
  handleMouseEnterOrMouseMove = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(false);
    this.props.onMouseEnter();
  };
  handleMouseLeave = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onMouseLeave();
  };
  handleClick = (e) => {
    //e.preventDefault(); // controlsが表示されなくなるのでcancelしない
    this.props.onOverlayFixed(false);
  };
  shouldComponentUpdate = (nextProps, nextState) => {
    return nextProps.channelLoaded !== this.props.channelLoaded;
  }
  render = () => {
    const isChannelLoaded = this.props.channelLoaded;
    if (!isChannelLoaded) {
      return (<div />);
    }
    const isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent);
    return (
      <div
        onMouseEnter={this.handleMouseEnterOrMouseMove}
        onMouseMove={this.handleMouseEnterOrMouseMove}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleClick}
        style={{position:'absolute',top: 0,left: 0, width:'100%', height: '100%'}}
      >
        <video id="video" autoPlay={true} playsInline={true} controls={isIOS}></video>
        <div id="text-track-container" />
      </div>
    );
  };
};
export default VideoArea;



// WEBPACK FOOTER //
// ./src/components/VideoArea.js